export const OPACITY_CHECK_TIMEOUT = 5000;
export const POST_WITHIN_METERS_TIMEOUT = 3000;
export const VISIBILITY_CHANGE_REFETCH_TIMEOUT = 5000;